<template>
    <v-app>
        <div class="header-strip">
            <a href="https://avfc.co.uk/">
                <img
                    src="./assets/logo.svg"
                    height="80"
                    width="80"
                    class="logo"
                />
            </a>
            <h1>{{ configStrings.AltProductName }}</h1>
        </div>
        <header
            class="header"
            v-if="showHeader"
        >
            <UserInfo
                class="user-info-container"
                v-if="$route.path === '/profile'"
            />
            <div v-else></div>

            <div
                class="mini-nav"
                v-if="ticketingRedirect"
            >
                <ul v-if="miniNavTicketingEnabled">
                    <li>
                        <a
                            v-on:click="redirectToTicketing()"
                            class="web-link"
                        >Return to Ticketing</a>
                    </li>
                </ul>
            </div>
            <div
                class="mini-nav"
                v-else-if="$route.path === '/profile'"
            >
                <ul>
                    {{
                        configStrings.clubName
                    }}
                    Official Websites
                    <li>
                        <a
                            href="https://avfc.co.uk/"
                            class="web-link"
                        >Official website</a>
                    </li>
                    <li>
                        <a
                            href="https://shop.avfc.co.uk/en/?_s=bm-FI-PSC-AVFC-Shop-Link-App"
                            class="web-link"
                        >Online store</a>
                    </li>
                    <li>
                        <a
                            href="https://tickets.avfc.co.uk"
                            class="web-link"
                        >Ticketing</a>
                    </li>
                    <li>
                        <a
                            href="https://avfc.co.uk/video"
                            class="web-link"
                        >Villa TV</a>
                    </li>
                    <li>
                        <a
                            href="https://rewards.avfc.co.uk"
                            class="web-link"
                        >Rewards</a>
                    </li>
                    <li>
                        <a
                            href="https://membership.avfc.co.uk/"
                            class="web-link"
                        >Memberships</a>
                    </li>
                </ul>
            </div>
            <div v-else></div>
        </header>

        <v-content>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
import Vue from "vue";
//import Vuetify from 'vuetify'
import CognitoPlugin from "./cognito-plugin.js";
import GlobalConfig from "./globalConfig.js";
import VueCookie from "vue-cookie";
import UserInfo from "@/components/UserInfo";

import Vuetify, {
    VApp, // required
    VAlert,
    VTabs,
} from "vuetify/lib";

import { Ripple } from "vuetify/lib/directives";

Vue.use(Vuetify, {
    components: {
        VApp,
        VAlert,
        VTabs,
    },
    directives: {
        Ripple,
    },
});

Vue.use(CognitoPlugin);
Vue.use(GlobalConfig);
Vue.use(VueCookie);
Vue.use(require("vue-moment"));

export default {
    name: "App",
    components: {
        UserInfo,
    },
    data() {
        return {
            loggedIn: false,
            referrer: null,
            showHeader: false,
            ticketingRedirect: null,
            miniNavTicketingEnabled: false,
        };
    },
    mounted() {
        //check if logout was requested
        if (window.location.href.includes("/partner/logout")) {
            this.$signOut();
            this.$router.push("/");
        }

        // simple referral tracking
        if (window.location.href.includes("referred=1")) {
            //if the user is referred from a partner site
            localStorage.referrer = document.referrer;
        }

        if (!window.location.href.includes("cross-site")) {
            //if the URL does not conatin cross-site
            this.showHeader = true;
        }

        var urlPieces = window.location.href.split("returnUrl=");
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = decodeURIComponent(urlPieces[1]); //we take the whole string after this param as it could itself contain params and we want to keep them
        const responseType = urlParams.get("responseType");
        const sendToken = urlParams.get("sendToken");

        if (window.location.href.includes("returnUrl=")) {
            //if the user is referred from the StreamAMG payments site

            var trustedSource = false;
            this.configTrustedDomains.forEach((domain) => {
                if (returnUrl.includes(domain)) {
                    trustedSource = true;
                }
            });

            if (trustedSource === true) {
                localStorage.returnUrl = returnUrl;
                if (sendToken == "false") {
                    localStorage.suppressToken = "true";
                } else {
                    localStorage.removeItem("suppressToken");
                }
                if (responseType == "post") {
                    localStorage.responseType = "post";
                } else {
                    localStorage.responseType = "get";
                }
            }
        }

        if (typeof localStorage.returnUrl != "undefined") {
            if (localStorage.returnUrl.includes("ticket")) {
                this.ticketingRedirect = localStorage.returnUrl;
            }
        }
        //Upon initial mount we check the authentication state

        if (this.$getAuthenticatedUser() != null) {
            this.$getCurrentUserAttributes().subscribe(
                (userData) => {
                    //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)

                    //

                    var additionalRegistrationFields = ["address"];

                    var proceed = true;

                    if ("custom:address_skip" in userData) {
                        // if they've previously skipped adding their address then (for now) we do nothing
                    } else {
                        // otherwise we do a check that they have populated their address yet
                        additionalRegistrationFields.forEach((element) => {
                            if (element in !userData) {
                                proceed = false;
                            }
                        });
                    }

                    if (
                        window.location.href.includes("/auth/logout") ||
                        window.location.href.includes("/link")
                    ) {
                        // then we let it through to the logout or link page
                    } else if (proceed === true) {
                        this.loggedIn = true;
                        //always force logged in users to their profile, unless they are already going there or the site is being accessed by a partner site
                        if (this.showHeader === true) {
                            if (this.$route.name != "profile") {
                                var passhash = new URL(document.URL).hash; //add hash check
                                this.$router.push("/profile" + passhash);
                            }
                        }
                    } else {
                        this.loggedIn = false;
                        this.$router.push("/complete-registration");
                    }
                },
                (err) => {
                    this.loggedIn = false;
                }
            );
        } else {
            this.loggedIn = false;
        }
    },
    methods: {
        redirectToTicketing() {
            var redirectTo = localStorage.returnUrl;
            localStorage.returnUrl = "";
            window.location = redirectTo;
        },
    },
    watch: {
        $route(to) {
            //Upon each route change we check the authentication state

            if (this.$getAuthenticatedUser() != null) {
                this.$getCurrentUserAttributes().subscribe(
                    (userData) => {
                        //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)

                        //

                        var additionalRegistrationFields = ["address"];

                        var proceed = true;

                        if ("custom:address_skip" in userData) {
                            // if they've previously skipped adding their address then (for now) we do nothing
                        } else {
                            // otherwise we do a check that they have populated their address yet
                            additionalRegistrationFields.forEach((element) => {
                                if (element in userData) {
                                    if (element === "address") {
                                        // Sometimes clubs set country in registration so we need to check first line

                                        if (!userData.address.includes("street_address")) {
                                            proceed = false;
                                        }
                                    }
                                } else {
                                    proceed = false;
                                }
                            });
                        }

                        if (
                            window.location.href.includes("/auth/logout") ||
                            window.location.href.includes("/link")
                        ) {
                            // then we let it through to the logout or link page
                        } else if (proceed === true) {
                            this.loggedIn = true;
                            //always force logged in users to their profile, unless they are already going there
                            if (this.$route.name != "profile") {
                                var passhash = new URL(document.URL).hash; //add hash check
                                this.$router.push("/profile" + passhash);
                            }
                        } else {
                            this.loggedIn = false;
                            this.$router.push("/complete-registration");
                        }
                    },
                    (err) => {
                        this.loggedIn = false;
                    }
                );
            } else {
                this.loggedIn = false;
            }
        },
    },
};
</script>

<style lang="scss">
@import "/css/global.scss";
</style>

<style lang="scss" scoped>
.header {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    padding: 20px 20px 0;
    margin: 0 0 35px;
}

.header-strip {
    width: 100%;
    color: #fff;
    background-color: #660033;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 10px 25px 5px 25px;
}

.header-strip img {
    display: inline;
}

.header-strip h1 {
    display: inline;
    margin-left: 20px;
    font-size: 1.5em;
}

.user-info-container {
    margin: 20px 0 0;
}

.cross-site-container {
    margin: 20px 0 0;
}

.button-home {
    display: none;
}

@media screen and (min-width: 700px) {
    .header {
        flex-direction: row;
        justify-content: space-between;
        padding: 48px 100px 48px;
    }

    .user-info-container {
        top: 43px;
        left: 20px;
        margin: 0;
    }

    .button-home {
        display: block;
    }
}

@media screen and (min-width: 1200px) {
    .header {
        padding: 48px 300px 48px;
    }
}

.mini-nav {
    width: 250px;
}

.mini-nav li {
    list-style: none;
}

.web-link {
    padding: 0;
    margin: 0 2px 0 0;
    color: #660033;
    font-size: 12px;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.page-title {
    color: #660033;
    font-size: 44px;
    text-align: left;
}
</style>
